<div *ngIf="user.profileId !== 2 && user.roleId !== 4" class="action_pb btn btn-dark btn-refresh" (click)="refresh()">
  <div class="action_refresh">
    <div class="action_refresh_icon"></div>
  </div>
</div>

<div *ngIf="user.roleId === 1 && configSvc.currentConfigValue.debug" class="action_pb btn btn-dark">
  <div class="action_new">
    <div class="action_new_icon"></div>
  </div>
  <div>
    <a [routerLink]="'/licenses/packages/create/'" class="btn btn-dark"><span>{{ 'COMMON.NEW_PACKAGE' | translate
        }}</span></a>
  </div>
</div>
<div *ngIf="user.roleId === 1 && configSvc.currentConfigValue.debug" class="action_pb btn btn-dark">
  <div class="action_new">
    <div class="action_new_icon"></div>
  </div>
  <div>
    <a [routerLink]="'/devices/create/'" class="btn btn-dark"><span>{{ 'COMMON.NEW_DEVICE' | translate
        }}</span></a>
  </div>
</div>
<form [formGroup]="packageForm" (ngSubmit)="checkExisitingPackagesBeforeSaving()">
  <div class="row p-4">
    <div class="col-6">
      <div *ngIf="action === 'create'" class="row mb-3">
        <label for="amount" class="col-sm-5 col-form-label">{{ 'LICENSE.PACKAGE_AMOUNT' | translate }}</label>
        <div class="col-sm-7">
          <input type="number" [class]="action === 'create' ? 'form-control' : 'form-control-plaintext'" id="amount"
            formControlName="amount" min="1" max="25">
          <hbo-control-messages [control]="packageForm.get('amount')!"
            [component]="'package-actions'"></hbo-control-messages>
        </div>
      </div>

      <div class="row mb-3">
        <label for="entityId" class="col-sm-5 col-form-label">{{ 'COMMON.ENTITY' | translate }}</label>
        <!--<div class="col-sm-7">
          <select [class]="action === 'create' ? 'form-select' : 'form-control-plaintext'" id="entityId" formControlName="entityId">
            <option [value]="entity.id" *ngFor="let entity of entities">{{ entity.name }}</option>
          </select>
          <hbo-control-messages [control]="packageForm.get('entityId')!"></hbo-control-messages>
        </div>-->
        <div *ngIf="package && action === 'edit'" class="col-sm-7 align_middle">
          {{effectiveOwner(package).name}}
        </div>
        <div *ngIf="(action === 'create' && entities.length)" class="col-sm-7">
          <!--<select class="form-select" [id]="'parentEntityId-' + entity.id" formControlName="parentEntityId">
            <ng-container *ngFor="let parentEntity of parentEntities">
              <option [value]="parentEntity.id"
                *ngIf="parentEntity.entityTypeId < utils.toNumber(entityForm.controls.entityTypeId?.value)">{{
                parentEntity.name }}</option>
            </ng-container>
          </select>-->
          <!--<hbo-single-select-multi-level *ngIf="action !== 'create' || configSvc.currentConfigValue.debug "
            [tree]="entities" [userEntity]="user" [typeData]="action === 'create' ?  'newPackage': 'package'"
            [max]="action === 'create' ? reactiveToRole : entity.entityTypeId" [selection]="entity"
            (ngModelChange)="onChange($event,'entity')" formControlName="entityId">
          </hbo-single-select-multi-level>-->
          <app-basic-virtual-scroll *ngIf="action === 'create' && configSvc.currentConfigValue.childEntities"
            (callback)="onChange($event,'entity')"
            [typeData]="'newPackage'"
            [customTreeNode]="entitiesForPackageCreation"></app-basic-virtual-scroll>
          <hbo-control-messages [control]="packageForm.get('entityId')!"></hbo-control-messages>
        </div>
      </div>

      <div class="row mb-3">
        <label for="packageTypeId" class="col-sm-5 col-form-label">{{ 'COMMON.TYPE' | translate }}</label>
        <div *ngIf="package && action === 'edit'" class="col-sm-7 align_middle">
          {{package.packageType.name}}
        </div>
        <div *ngIf="action !== 'edit'" class="col-sm-7">
          <!--<select [class]="action === 'create' ? 'form-select' : 'form-control-plaintext'" id="packageTypeId" formControlName="packageTypeId">
            <option [value]="packageType.id" *ngFor="let packageType of packageTypes">{{ packageType.name }}</option>
          </select>
          <hbo-control-messages [control]="packageForm.get('packageTypeId')!"></hbo-control-messages>-->
          <div class='form-select-ng'>
            <ng-select formControlName="packageTypeId" name="packageTypeId" [items]="packageTypes" [multiple]="false"
              [searchable]="false" bindLabel="name" bindValue="id"
              placeholder="{{'DATATABLE.FILTERS.PACKAGETYPE' | translate}}"
              (ngModelChange)="onChange($event,'packageType')"
              [ngClass]="{'single-select-multi-level-disabled':action === 'edit'}"></ng-select>
            <!--<ng-select [searchable]="false" formControlName="packageTypeId" labelForId="yesno"
              placeholder="{{'DATATABLE.FILTERS.PACKAGETYPE' | translate}}"
              (ngModelChange)="onChange($event,'packageType')">

              [(ngModel)]="selectedPackageTypeId"
              package-actions.component.html:50
              It looks like you're using ngModel on the same form field as formControlName.
              Support for using the ngModel input property and ngModelChange event with
              reactive form directives has been deprecated in Angular v6 and will be removed
              in a future version of Angular.

              For more information on this, see our API docs here:
              https://angular.io/api/forms/FormControlName#use-with-ngmodel

              <ng-option *ngFor="let packageType of packageTypes"
                [value]="packageType.id">{{packageType.name}}</ng-option>
            </ng-select>-->
            <hbo-control-messages [control]="packageForm.get('packageTypeId')!"></hbo-control-messages>
          </div>
        </div>
      </div>

      <div class="row mb-3">
        <label for="packageCategoryId" class="col-sm-5 col-form-label">{{ 'LICENSE.CATEGORY' | translate }}</label>
        <div *ngIf="package && action === 'edit'" class="col-sm-7 align_middle">
          <span
            [className]="package.packageCategoryId ===2 ? 'badge text-bg-warning rounded-pill' :''">{{('LICENSE.'+(package.category.name
            | uppercase )) | translate}}</span>
        </div>
        <div *ngIf="action !== 'edit'" class="col-sm-7">
          <!--<select [class]="action === 'create' ? 'form-select' : 'form-control-plaintext'" id="category"
            formControlName="category">
            <option value="1">{{ 'LICENSE.OPERATIONAL' | translate }}</option>
          </select>
          <hbo-control-messages [control]="packageForm.get('category')!"></hbo-control-messages>-->
          <div id="packageCategoryId" class='form-select-ng'>
            <ng-select formControlName="packageCategoryId" name="packageCategoryId" [items]="categories"
              [clearable]="false" [multiple]="false" [searchable]="false" bindLabel="name" bindValue="id"
              placeholder="{{'LICENSE.CATEGORY' | translate}}" (ngModelChange)="onChange($event,'category')"
              [ngClass]="{'single-select-multi-level-disabled': action === 'edit'}">
              <ng-template ng-option-tmp ng-label-tmp let-item="item">
                {{('LICENSE.'+item.name) | translate}}
              </ng-template>
            </ng-select>
            <hbo-control-messages [control]="packageForm.get('packageCategoryId')!"></hbo-control-messages>
          </div>
        </div>
      </div>

      <div *ngIf="packageForm.controls.packageCategoryId.value !='2'" class="row mb-3">
        <label for="packagePeriodId" class="col-sm-5 col-form-label">{{ 'LICENSE.PERIOD' | translate }}</label>
        <div *ngIf="package && action === 'edit'" class="col-sm-7 align_middle">
          {{package.period.name}}
        </div>
        <div *ngIf="action !== 'edit'" class="col-sm-7">
          <!--<select [class]="action === 'create' ? 'form-select' : 'form-control-plaintext'" id="period"
            formControlName="period">
            <option value="0">{{ 'LICENSE.ANNUAL' | translate }}</option>
          </select>
          <hbo-control-messages [control]="packageForm.get('c')!"></hbo-control-messages>-->
          <div class='form-select-ng'>
            <ng-select id="packagePeriodId" formControlName="packagePeriodId" name="packagePeriodId"
              [multiple]="false" [searchable]="false"
              placeholder="{{'LICENSE.PERIOD' | translate}}" (ngModelChange)="onChange($event,'period')"
              [ngClass]="{'single-select-multi-level-disabled':action === 'edit'}">
              <ng-option *ngFor="let period of periods" [value]="period.id" [disabled]="period.disabled">
                {{period.name}}
              </ng-option>
            </ng-select>
            <hbo-control-messages [control]="packageForm.get('packagePeriodId')!"></hbo-control-messages>
          </div>
        </div>
      </div>
      <div *ngIf="packageForm.controls.packageCategoryId.value !='2'" class="row mb-3">
        <label for="testDays" class="col-sm-5 col-form-label">{{ 'LICENSE.ASSIGNED_TEST_DAYS' | translate }}</label>
        <div class="col-sm-7">
          <input type="number" [class]="action === 'create' ? 'form-control' : 'form-control-plaintext'" id="testDays"
            formControlName="testDays" min="0">
          <hbo-control-messages [control]="packageForm.get('testDays')!"></hbo-control-messages>
          <!--<input type="number" [class]="action === 'create' ? 'form-control' : 'form-control-plaintext'" id="testDays" formControlName="testDays">
          <hbo-control-messages [control]="packageForm.get('testDays')!"></hbo-control-messages>-->
        </div>
      </div>

      <div *ngIf="action === 'edit' && package?.assigned?.entityTypeId===4" class="row mb-3">
        <label for="deviceId" class="col-sm-5 col-form-label">SN/MAC</label>
        <div
          *ngIf="(package.upgradedAt && package.packageUpgradeId) || package.inactiveDate || !devices.length || (package.deviceId || (!package.deviceId && !linksInvisionDevice))"
          class="col-sm-5 align_middle">
          {{ package.device?.serialNumber ? package.device?.serialNumber : "-" }}
        </div>
        <div
          *ngIf="!package.inactiveDate && devices.length && (!package.deviceId && linksInvisionDevice)"
          class="col-sm-5">
          <div class='form-select-ng me-2'>
            <ng-select id="deviceId" formControlName="deviceId" name="deviceId" [items]="devices" [multiple]="false"
              [searchable]="false" bindLabel="snMac" bindValue="id" placeholder="{{'COMMON.DEVICE' | translate}}"
              (ngModelChange)="onChange($event,'device')"
              [ngClass]="{'single-select-multi-level-disabled': package.deviceId}">
            </ng-select>
            <hbo-control-messages [control]="packageForm.get('deviceId')!"></hbo-control-messages>
          </div>
        </div>
        <div
          *ngIf="!package.inactiveDate && devices.length && ((!package.deviceId && linksInvisionDevice) || package.deviceId)"
          class="col-sm-2">
          <button type="button" [disabled]="!package.deviceId && !packageForm.get('deviceId')?.value"
            class="btn btn-outline-secondary me-2 link-unlink-device-pb" (click)="link()">
            <div class="unlink-device-icon"></div>
            {{ (package.deviceId ? 'LICENSE.UNLINK_DEVICE' : 'LICENSE.LINK_DEVICE') | translate }}
          </button>
        </div>
      </div>
    </div>

    <div class="col-6" *ngIf="user.roleId === 1 && packageForm.get('packageTypeId')!.value!">
      <h4 class="pb-2 mb-3 border-bottom fw-bold">{{ 'LICENSE.PACKAGE_TYPE_DETAILS' | translate }}</h4>
      <div class="row mb-3">
        <label for="apps" class="col-sm-5 col-form-label">{{ 'LICENSE.APPS_INCLUDED' | translate }}</label>
        <div *ngIf="!selectedPackageType && package?.packageType?.appPackages"
          class="col-sm-7 d-flex align-items-center">
          <ng-container
            *ngFor="let appPackage of (package?.packageType?.appPackages! |sortArray:'appId'); let last = last">
            {{ appPackage.app.abbreviation }}<ng-container *ngIf="!last"> - </ng-container>
          </ng-container>
          <!--<input type="text" class="form-control-plaintext" id="apps" formControlName="apps">
          <hbo-control-messages [control]="packageForm.get('apps')!"></hbo-control-messages>-->
        </div>
        <div *ngIf="selectedPackageType" class="col-sm-7 d-flex align-items-center">
          <ng-container
            *ngFor="let appPackage of (selectedPackageType?.appPackages!|sortArray:'appId'); let last = last">
            {{ appPackage.app.abbreviation }}<ng-container *ngIf="!last"> - </ng-container>
          </ng-container>
          <!--<input type="text" class="form-control-plaintext" id="apps" formControlName="apps">
          <hbo-control-messages [control]="packageForm.get('apps')!"></hbo-control-messages>-->
        </div>
      </div>

      <div class="row mb-3">
        <label for="private" class="col-sm-5 col-form-label">{{ 'LICENSE.PRIVACY' | translate }}</label>
        <div class="col-sm-7">
          <select class="form-control-plaintext" id="private" formControlName="private">
            <option value="false">{{ 'LICENSE.PUBLIC' | translate }}</option>
            <option value="true">{{ 'LICENSE.PRIVATE' | translate }}</option>
          </select>
          <hbo-control-messages [control]="packageForm.get('private')!"></hbo-control-messages>
        </div>
      </div>
    </div>
  </div>

  <div class="p-4" *ngIf="action === 'create'">
    <button type="button" class="btn btn-outline-secondary me-2" (click)="cancel()">{{ 'COMMON.CANCEL' | translate
      }}</button>
    <button class="btn btn-dark" [ngClass]="{'custom-file-button-disabled':!packageForm.valid}">{{
      'COMMON.CREATE_PACKAGE' | translate }}</button>
  </div>

  <div class="p-4" *ngIf="action === 'edit'">
    <table class="table table-secondary">
      <thead>
        <tr>
          <th>#</th>
          <th>ID</th>
          <th>Type</th>
          <th>Status</th>
          <th>Assigned Date</th>
          <th>Test Date</th>
          <th>Remaining Test Days</th>
          <th>Activation Date</th>
          <th>Inactivation Date</th>
          <th>Renewal Date</th>
        </tr>
      </thead>
      <tbody>
        <tr *ngIf="package">
          <td>P</td>
          <td>{{ package.id }}</td>
          <td>{{ package.packageType.name }}</td>
          <td>
            <span class="badge rounded-pill text-bg-secondary" *ngIf="package.packageStatusId === 1">{{
              'LICENSE.ASSIGNED' | translate }}</span>
            <span class="badge rounded-pill text-bg-warning" *ngIf="package.packageStatusId === 2">{{ 'LICENSE.TEST' |
              translate }}</span>
            <span class="badge rounded-pill text-bg-success" *ngIf="package.packageStatusId === 3">{{ 'LICENSE.ACTIVE' |
              translate }}</span>
            <span class="badge rounded-pill text-bg-danger" *ngIf="package.packageStatusId === 4">{{
              'LICENSE.INACTIVE_REQUEST' | translate }}</span>
            <span class="badge rounded-pill text-bg-secondary" *ngIf="package.packageStatusId === 5">{{
              'LICENSE.INACTIVE' | translate }}</span>
            <span class="badge rounded-pill text-bg-warning" *ngIf="package.packageStatusId === 6">{{
              'LICENSE.IN_UPGRADE' | translate }}</span>
          </td>
          <td>{{ package.assignedAt | date:(configSvc.currentConfigValue.debug ? 'yyyy/MM/dd HH:mm':'yyyy/MM/dd' )}}
          </td>
          <td><!--{{ preventFromTimezone(package.testStartDate)!}} ||| -->
            {{ (package.testStartDate! | date:(configSvc.currentConfigValue.debug ? 'yyyy/MM/dd HH:mm':'yyyy/MM/dd' ))
            ?? '-'}}</td>
          <!--<td>{{ (package.testStartDate ? package.testStartDate : setPackageLabelDate('testStartDate')!) |
            date:'yyyy/MM/dd HH:mm'}}</td>-->
          <td>{{ package.packageCategoryId == 1 ? package.remainingTestDays : '-' }}<span class="package-test-days">{{
              package.packageCategoryId == 1 ? ' / '+package.testDays : '' }}</span></td>
          <!--<td>{{ package.packageCategoryId == 1 ? (package.activationDate ? package.activationDate :
            (setPackageLabelDate('activationDate')!) | date:'yyyy/MM/dd
            HH:mm'):'-'}}</td>-->
          <td>{{( package.packageCategoryId == 1 ? (package.activationDate! | date:(configSvc.currentConfigValue.debug ?
            'yyyy/MM/dd HH:mm':'yyyy/MM/dd' )):'-') ?? '-'}}</td>
          <!--<td
            [ngClass]="{'inactiveDate-td':setPackageLabelDate('inactiveDate'),'inactiveRequestDate-td':!setPackageLabelDate('inactiveDate')}">
            {{ package.upgradedAt ? (package.upgradedAt | date:'yyyy/MM/dd HH:mm') :
            (((package.inactiveDate ? package.inactiveDate : setPackageLabelDate('inactiveDate') ??
            setPackageLabelDate('inactiveRequestDate')!)) | date:'yyyy/MM/dd
            HH:mm')}}</td>-->
          <td
            [ngClass]="{'inactiveDate-td':package.inactiveDate,'inactiveRequestDate-td':package.inactiveRequestDate && !package.inactiveDate}">
            {{ ((package.upgradedAt && package.packageUpgradeId) ? (package.upgradedAt |
            date:(configSvc.currentConfigValue.debug ? 'yyyy/MM/dd HH:mm':'yyyy/MM/dd' ))
            :((package.inactiveDate ?
            package.inactiveDate : (package.packageStatusId===4 ? package.renewalPersDate! :'') )|
            date:(configSvc.currentConfigValue.debug ? 'yyyy/MM/dd HH:mm':'yyyy/MM/dd' ))) ?? '-'}}</td>
          <!--recalculateRenewal(package)!-->
          <!--<td>{{ package.packageCategoryId == 1 ? ((package.renewalDate ? package.renewalDate :
            setPackageLabelDate('renewalDate'))| date:'yyyy/MM/dd HH:mm') : '-'}}
          </td>-->
          <td><!--{{ package.renewalDate! | date:'short':'UTC +1' }} ||| 
            {{ preventFromTimezone(package.renewalDate)!}} ||| -->
            {{ (package.packageCategoryId == 1 ? (package.renewalInvoiceableDate! |
            date:(configSvc.currentConfigValue.debug ? 'yyyy/MM/dd HH:mm':'yyyy/MM/dd' )) : '-') ??
            '-'}}</td>
        </tr>
        <tr *ngFor="let license of (policy?.seeLicenses || user.roleId === 1 ? package?.licenses : [])">
          <td>L</td>
          <td>{{ license.id }}</td>
          <td>{{ license.app.abbreviation }}</td>
          <td>
            <span class="badge rounded-pill text-bg-secondary" *ngIf="license.licenseStatusId === 1">{{
              'LICENSE.ASSIGNED' | translate }}</span>
            <span class="badge rounded-pill text-bg-warning" *ngIf="license.licenseStatusId === 2">{{ 'LICENSE.TEST' |
              translate }}</span>
            <span class="badge rounded-pill text-bg-success" *ngIf="license.licenseStatusId === 3">{{ 'LICENSE.ACTIVE' |
              translate }}</span>
            <span class="badge rounded-pill text-bg-danger" *ngIf="license.licenseStatusId === 4">{{
              'LICENSE.INACTIVE_REQUEST' | translate }}</span>
            <span class="badge rounded-pill text-bg-secondary" *ngIf="license.licenseStatusId === 5">{{
              'LICENSE.INACTIVE' | translate }}</span>
          </td>
          <td>{{ license.statusDate?.assignedDate | date:(configSvc.currentConfigValue.debug ? 'yyyy/MM/dd
            HH:mm':'yyyy/MM/dd' ) }}</td>
          <td>{{ (license.statusDate?.testStartDate | date:(configSvc.currentConfigValue.debug ? 'yyyy/MM/dd
            HH:mm':'yyyy/MM/dd' )) ?? '-' }}</td>
          <td>{{ package.packageCategoryId == 1 ? license.testDays : '-'}} <span class="package-test-days">{{
              package.packageCategoryId == 1
              ? ' /'+( (!license.statusDate?.testStartDate || (license.statusDate?.testStartDate &&
              !license.statusDate?.renewalPersDate && !license.statusDate?.activationDate)) ? package.testDays :
              getTestDays(license.testDays,license.statusDate))
              : '' }}</span>
            <!--<td>{{ package.packageCategoryId == 1 ? license.testDays : '-'}} <span class="package-test-days">{{
              package.packageCategoryId == 1 ? ' /'+(package.upgradedAt && package.packageOriginId && license.packageId
              !== license.firstPackageId && !onlyInheritedLicenses()? getTestDaysInheritedLicense(package.testStartDate,
              license.statusDate?.testStartDate!,license.statusDate,license.testDays) : !license.testDays ?
              getTestDays(license.statusDate) : package.testDays) : '' }}</span>-->
          </td>
          <td>{{ (license.statusDate?.activationDate | date:(configSvc.currentConfigValue.debug ? 'yyyy/MM/dd
            HH:mm':'yyyy/MM/dd' )) ?? '-' }}</td>
          <td
            [ngClass]="{'inactiveDate-td':license.statusDate?.inactiveDate,'inactiveRequestDate-td':license.statusDate?.inactiveRequestDate && !license.statusDate?.inactiveDate}">
            {{ ((license.statusDate?.inactiveDate ?? (package.packageStatusId===4 ? package.renewalPersDate!: ''))
            | date:(configSvc.currentConfigValue.debug ? 'yyyy/MM/dd HH:mm':'yyyy/MM/dd' ) ) ?? '-'}}</td>
          <!--recalculateRenewal(package)! -->
          <td>{{ (license.statusDate?.renewalInvoiceableDate | date:(configSvc.currentConfigValue.debug ? 'yyyy/MM/dd
            HH:mm':'yyyy/MM/dd' )) ?? '-' }}</td>
        </tr>
      </tbody>
    </table>
    <div>
      <div *ngIf="package?.inactiveRequestDate" class="upgraded-message-container"><span>{{
          package.inactiveRequestDate |date:(configSvc.currentConfigValue.debug ? 'yyyy/MM/dd HH:mm':'yyyy/MM/dd' )}} {{
          'LICENSE.INACTIVE_REQUEST_DATE' |translate
          }}</span></div>

      <div *ngIf="package && package.upgradedAt && package.packageUpgradeId" class="upgraded-message-container"><span>{{
          package.upgradedAt |
          date:(configSvc.currentConfigValue.debug ? 'yyyy/MM/dd HH:mm':'yyyy/MM/dd' )}} - {{ 'COMMON.MODIFY.MODIFY_BY'
          |
          translate:{ x: package.packageUpgradeId } }}</span><i class="bi bi-arrow-up-square-fill go"
          [routerLink]="'/licenses/packages/edit/'+package.packageUpgradeId"></i></div>
      <div *ngIf="package && package.upgradedAt && package.packageUpgradeId && invoiceable()"
        class="upgraded-message-container"><span>{{
          'COMMON.MODIFY.INVOICEABLE' |
          translate}}</span></div>
      <div *ngIf="package && package.packageOriginId && package.packageOriginId != 1"
        class="upgraded-message-container"><span>{{
          (package.inactiveDate && !(package.packageOriginId && package.packageUpgradeId)?
          'COMMON.MODIFY.DEACTIVE_UPGRADE_CANCELED' : 'COMMON.MODIFY.MODIFY_TO' ) | translate:{
          x:
          package.packageOriginId } }}</span><i class="bi bi-arrow-down-square-fill go"
          [routerLink]="'/licenses/packages/edit/'+package.packageOriginId"></i></div>
      <div *ngIf="package && package.packageOriginId && inheritedLicensesInvoiceable()"
        class="upgraded-message-container"><span *ngIf="package.packageOriginId">{{
          'COMMON.MODIFY.INVOICEABLE' |
          translate}}</span></div>
      <div
        *ngIf="user.roleId === 1 && package && package.packageOriginId && package.packageStatusId === 3 && package.packageOrigin?.renewalPersDate"
        class="upgraded-message-container">{{'COMMON.MODIFY.CANCELABLE_INSTEAD_ACTIVE' |translate}}</div>
      <!--&& (activePackageFromUpgradeOnlyInheritedLicenses() || activePackageFromUpgradeOnlyNewLicenses())-->
      <div *ngIf="package 
        && package.packageUpgradeId 
        && package.packageStatusId === 5 " class="upgraded-message-container">
        {{((invoiceable() || !package.activationDate) || (!invoiceable() && package.activationDate)) &&
        package.renewalPersDate && package.packageUpgradeStatus?.packageStatusId ===6? ('COMMON.MODIFY.RECOVERABLE'
        |translate) :''}}
      </div>
      <div *ngIf="package 
        && package.packageUpgradeId 
        && package.packageStatusId === 5 " class="upgraded-message-container">
        {{!invoiceable() || package.activationDate? (fullBilled(package) && user.roleId=== 1)
        ?(package.renewalPersDate | date:(configSvc.currentConfigValue.debug ? 'yyyy/MM/dd HH:mm':'yyyy/MM/dd' ))+'
        '+('COMMON.MODIFY.FULL_BILLED' |translate) :'':''}}
      </div>
      <div *ngIf="package 
        && package.packageOriginId 
        && package.packageStatusId === 6 " class="upgraded-message-container">{{'COMMON.MODIFY.RECOVERABLE'
        |translate}}</div>
    </div>
  </div>
  <div *ngIf="package && action === 'edit' && user.profileId !== 2" class="row p-4 ">
    <div class="col-sm-12 d-flex align-items-center">
      <button *ngIf="actionsPackageLicenseVisibility('cancel_upgrade')" type="button"
        class="btn btn-outline-secondary me-2 action-package-pb" (click)="cancelUpgrade()">
        <div class="cancel-upgrade-package-icon"></div>
        {{ 'LICENSE.CANCEL_UPGRADE' | translate }}
      </button>
      <button *ngIf="actionsPackageLicenseVisibility('modify')" type="button"
        class="btn btn-outline-secondary me-2 action-package-pb" data-bs-toggle="modal"
        [attr.data-bs-target]="'#reassignModal'">
        <div class="modify-package-icon"></div>
        {{ 'LICENSE.MODIFY' | translate }}
      </button>
      <button *ngIf="actionsPackageLicenseVisibility('deactivate') && (user.profileId === 3 || package.packageCategoryId !== 1)" type="button"
        class="btn btn-outline-secondary me-2 action-package-pb" data-bs-toggle="modal"
        [attr.data-bs-target]="'#deactiveModal-' + package.id!">
        <div class="deactive-package-icon"><i class="bi bi-bag-x"></i></div>
        <span>{{ 'LICENSE.DEACTIVATE' | translate }}</span>
      </button>
      <button *ngIf="actionsPackageLicenseVisibility('reactivate') && (user.profileId === 3 || package.packageCategoryId !== 1) && package.id != 1"
        type="button" class="btn btn-outline-secondary me-2 action-package-pb" data-bs-toggle="modal"
        [attr.data-bs-target]="'#reactiveModal-' + package.id!">
        <div class="reactive-package-icon"><i class="bi bi-bag-check"></i></div>
        <span>{{ 'LICENSE.REACTIVATE' | translate }}</span>
      </button>
      <button *ngIf="actionsPackageLicenseVisibility('delete_permanently') && user.profileId !== 2" type="button"
        class="btn btn-outline-secondary me-2 action-package-pb" data-bs-toggle="modal"
        [attr.data-bs-target]="'#confirmationModal-' + package.id!">
        <div class="delete-package-icon"></div>
        {{ 'LICENSE.DELETE_PERMANENTLY' | translate }}
      </button>
      <button *ngIf="actionsPackageLicenseVisibility('cancel_renewal')" type="button"
        class="btn btn-outline-secondary me-2 action-package-pb" (click)="cancelRenewal()">
        <div class="cancel-renewal-package-icon"></div>
        {{ 'LICENSE.CANCEL_RENEWAL' | translate }}
      </button>
      <button *ngIf="actionsPackageLicenseVisibility('recoverRenewal')" type="button"
        class="btn btn-outline-secondary me-2 action-package-pb" (click)="recoverRenewal()">
        <div class="recover-package-icon"></div>
        {{ 'LICENSE.RECOVER_RENEWAL' | translate }}
      </button>
      <button *ngIf="canReassign && user.roleId !== 4 && (user.profileId === 3 || user.profileId === 1)"
        type="button" class="btn btn-outline-secondary me-2 action-package-pb"
        data-bs-toggle="modal" data-bs-target="#noDeviceReassignModal">
        <div class="action_reassign_icon"></div>
        {{ 'PACKAGES.ASSIGN_PACKAGE' | translate }}
      </button>
      <!-- Package still parked at a head office/distributor: same entry point the package list offers -->
      <button *ngIf="canAssignFromParent" type="button" class="btn btn-outline-secondary me-2 action-package-pb"
        (click)="packageToAssign = package" data-bs-toggle="modal" data-bs-target="#reassignModal-assign">
        <div class="action_reassign_icon"></div>
        {{ 'PACKAGES.ASSIGN_PACKAGE' | translate }}
      </button>
    </div>
  </div>
</form>
<div *ngIf="user.roleId == 1 && package && action !== 'create' && user.profileId !== 2" class="row p-4 ">
  <label class="col-form-label">{{'LICENSE.COMMENTS' | translate}}</label>
  <div class="col-sm-10 comments-form">
    <input type="text" class="form-control" id="comments" [(ngModel)]="displayComments" [readonly]="!editComments"
      maxlength="150">
    <button *ngIf="editComments" type="button" class="btn btn-dark" (click)="saveComments()"><img
        src="assets/images/icons/send.svg"> {{
      'LICENSE.SAVE_SEND_COMMENTS' | translate }}</button>
    <div><i class="bi bi-pencil" (click)="editComments = !editComments"></i></div>
  </div>
  <div *ngIf="editComments" class="col-sm-10 comments-form-max">
    {{'LICENSE.COMMENTS_MAX_CHARS' | translate }}
  </div>
</div>

<hbo-confirmation-modal *ngIf="package" [id]="package.id!" (confirm)="delete()"></hbo-confirmation-modal>

<hbo-deactive-modal *ngIf="package" [id]="package.id!" (confirm)="deactive()"></hbo-deactive-modal>

<hbo-reactive-modal *ngIf="package" [id]="package.id!" (confirm)="reactive()"></hbo-reactive-modal>

<hbo-reassign-modal *ngIf="package && packageTypes" [package_types_filter]="packageTypes" [action]="'modify'"
  [package]="package!" [canceledUpgradeId]="user.roleId !== 1 ? package.canceledUpgradeId : null"></hbo-reassign-modal>

<!-- Same-group warning for the assign flow. Its own ids: `admin-some-license` without suffix belongs
  to the package creation flow below, whose accept bounces to the creation confirmation instead. -->
<hbo-confirmation-modal [id]="'some-license-inactive-assign'" [hideConfirm]="true"
  (confirm)="backConfirmAssignPackageModal()" [head]="'COMMON.REASSIGN.SOME_LICENSE_SAME_GROUP'"
  [head5]="'('+licenseInactiveData+')'"
  [extendedMessage]="'COMMON.REASSIGN.SOME_LICENSE_SAME_GROUP_EXTENDED'" [message]="'COMMON.EMPTY_STRING'"
  [cancelText]="'COMMON.UNDERSTAND'"></hbo-confirmation-modal>

<hbo-confirmation-modal [id]="'admin-some-license-assign'" [hideConfirm]="true"
  (confirm)="backConfirmAssignPackageModal()" [head]="'COMMON.REASSIGN.SOME_LICENSE_SAME_GROUP'"
  [message]="licenseWarningNoDevice ? 'COMMON.REASSIGN.SOME_LICENSE_SAME_GROUP_ADMIN_NO_DEVICE' : 'COMMON.REASSIGN.SOME_LICENSE_SAME_GROUP_ADMIN'"
  [cancelText]="'COMMON.UNDERSTAND'"></hbo-confirmation-modal>

<hbo-reassign-modal *ngIf="package && packageTypes" [id]="'assign'" [presetPackage]="packageToAssign"
  (modalsCrossData)="setLicenseData($event)" (closed)="packageToAssign = null"
  [package_types_filter]="packageTypes" [entity]="entity" [action]="'reassign'"
  (confirm)="refresh()"></hbo-reassign-modal>

<hbo-confirmation-create-package-modal *ngIf="package" [id]="package.id!"
  [packageTypeId]="packageForm.controls.packageTypeId!.value!" (confirm)="save()" [packages]="createdPackages"
  (selectedPackage)="selectedPackage($event)" [testDays]="convertToNumber(packageForm.controls.testDays!.value)"
  [error]="errorWhileCreating"></hbo-confirmation-create-package-modal>

<hbo-progress-modal [total]="totalPackages" [createdNumber]="createdPackagesNumber"
  [modifyingPackage]="modifyingPackage" [endModify]="endModify" [createdPackageId]="createdPackageId"
  [error]="errorCreation" [extendedMessage]="creationError!"
  (confirm)="continueCreating()"></hbo-progress-modal>

<hbo-confirmation-modal [id]="'admin-some-license'" [hideConfirm]="true" (confirm)="backConfirmCreatePackageModal($event)"
  [head]="'COMMON.REASSIGN.SOME_LICENSE_SAME_GROUP'"
  [message]="licenseWarningNoDevice ? 'COMMON.REASSIGN.SOME_LICENSE_SAME_GROUP_ADMIN_NO_DEVICE' : 'COMMON.REASSIGN.SOME_LICENSE_SAME_GROUP_ADMIN'"
  [cancelText]="'COMMON.UNDERSTAND'"></hbo-confirmation-modal>

<hbo-no-device-reassign-modal
  [package]="package"
  (confirmed)="refresh()">
</hbo-no-device-reassign-modal>